import React, { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	Grid,
	Typography,
	Switch,
	List,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
} from '@mui/material';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import useDebouncedForm from 'common/hooks/useDebouncedForm';

import ContainerBox from 'components/ContainerBox';
import * as ActiveProductActions from 'actions/ActiveProductActions';
import * as ActiveProductSelectors from 'selectors/ActiveProductSelectors';
import { useTranslation } from 'services/localization/useTranslation';

const SkidataDetailsBlock = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const product = useSelector(ActiveProductSelectors.productDataWithChanges);

	const { state, editState } = useDebouncedForm({
		memoizedInitialState: useMemo(
			() => ({
				skidataProperties: product.skidataProperties,
			}),
			[product],
		),
		memoizedOnDebounce: useCallback(
			(changes) => {
				dispatch(ActiveProductActions.editLocalProduct(changes));
			},
			[dispatch],
		),
	});

	return (
		<ContainerBox>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h6">
						{t('product.skidataInformationAskedFromCustomer', 'Customer information for Skidata')}
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<List>
						<ListItem className={classes.listItem}>
							<ListItemText primary={t(`common:form.photo`, 'Photo')} />
							<ListItemSecondaryAction>
								<Switch
									checked={!!state.skidataProperties?.requirePhoto}
									onChange={(e) =>
										editState({
											skidataProperties: {
												requirePhoto: e.target.checked,
											},
										})
									}
									name="requirePhoto"
									color="primary"
								/>
							</ListItemSecondaryAction>
						</ListItem>
					</List>
				</Grid>
			</Grid>
		</ContainerBox>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		listItem: {
			paddingTop: theme.spacing(2),
			paddingBottom: theme.spacing(2),
			'&:hover': {
				background: 'rgba(0,0,0,0.03)',
			},
		},
	}),
);

export default SkidataDetailsBlock;
